export const filterMetricas = (user, metricaV) => {
    return user.Metricas.filter(metric => metric.nombre === metricaV)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
}